import React from 'react';
import { ChevronRightRounded as ChevronRightRoundedIcon } from '@mui/icons-material';
import { Box, ListItemButton, Tooltip, Typography } from '@mui/material';
import { guaranteesLayoutStyles } from '../../styles.ts';
import {
  getCompactNavigationIcon,
  getNavigationItemPath,
  isNavigationItemActive,
  isNavigationItemGroup,
} from '../../utils.ts';
import type { ICompactNavigationButtonProps, ICompactNavigationItemProps } from './types.ts';

const CompactNavigationButton: React.FC<ICompactNavigationButtonProps> = ({
  isActive,
  isGroup,
  navigationItem,
  onClick,
  onFocus,
  title,
}) => {
  const ItemIcon = getCompactNavigationIcon(navigationItem);

  return (
    <ListItemButton
      onClick={onClick}
      onFocus={onFocus}
      sx={guaranteesLayoutStyles.menuCompactItemButton(isActive)}
    >
      <Box sx={guaranteesLayoutStyles.menuCompactBadge(isActive)}>
        <ItemIcon sx={guaranteesLayoutStyles.menuCompactIcon(isActive)} />
        {isGroup ? (
          <ChevronRightRoundedIcon sx={guaranteesLayoutStyles.menuCompactGroupArrow(isActive)} />
        ) : null}
      </Box>
      <Box sx={guaranteesLayoutStyles.menuCompactLabelRow}>
        <Typography sx={guaranteesLayoutStyles.menuCompactLabel(isActive)}>{title}</Typography>
      </Box>
    </ListItemButton>
  );
};

const CompactNavigationItem: React.FC<ICompactNavigationItemProps> = ({
  activeCompactGroupSegment,
  currentPath,
  item,
  onGroupHoverChange,
  onGroupOpen,
  onNavigate,
}) => {
  const isGroup = isNavigationItemGroup(item);
  const isActive = isNavigationItemActive(currentPath, item);
  const isCompactGroupOpen = isGroup && activeCompactGroupSegment === item.segment;
  const isCompactItemActive = isActive || isCompactGroupOpen;
  const groupContent = (
    <Box
      onMouseEnter={() => onGroupHoverChange(item.segment)}
      onMouseLeave={() => onGroupHoverChange(null)}
      sx={guaranteesLayoutStyles.menuCompactGroupWrap}
    >
      <CompactNavigationButton
        isActive={isCompactItemActive}
        isGroup
        navigationItem={item}
        onClick={() => onGroupOpen(item.segment)}
        onFocus={() => onGroupHoverChange(item.segment)}
        title={item.title}
      />
    </Box>
  );
  const linkContent = (
    <Tooltip title={item.title} placement="right">
      <Box>
        <CompactNavigationButton
          isActive={isActive}
          isGroup={false}
          navigationItem={item}
          onClick={() => onNavigate(getNavigationItemPath(item))}
          title={item.title}
        />
      </Box>
    </Tooltip>
  );

  return isGroup ? groupContent : linkContent;
};

export default CompactNavigationItem;
